export const paymentMode = [
    {
        "Code": "01",
        "Payment Method": "Cash"
    },
    {
        "Code": "02",
        "Payment Method": "Cheque"
    },
    {
        "Code": "03",
        "Payment Method": "Bank Transfer"
    },
    {
        "Code": "04",
        "Payment Method": "Credit Card"
    },
    {
        "Code": "05",
        "Payment Method": "Debit Card"
    },
    {
        "Code": "06",
        "Payment Method": "e-Wallet / Digital Wallet"
    },
    {
        "Code": "07",
        "Payment Method": "Digital Bank"
    },
    {
        "Code": "08",
        "Payment Method": "Others"
    }
]